// src/components/shared/forms/RichTextEditor.jsx
import React from 'react';
import { TextArea } from './FormComponents';

export const RichTextEditor = ({ 
  value, 
  onChange, 
  placeholder = "Write your content...",
  disabled = false 
}) => {
  // For now, use a simple textarea - can be enhanced with a rich text editor later
  // TODO: Replace with actual rich text editor like Quill, TinyMCE, or Draft.js
  
  return (
    <div className="space-y-2">
      <div className="text-sm text-gray-500 mb-2">
        Rich text editor (basic implementation)
      </div>
      <TextArea
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        rows={8}
        disabled={disabled}
        className="font-mono text-sm"
      />
      <div className="text-xs text-gray-400">
        HTML tags are supported. Rich text editor coming soon.
      </div>
    </div>
  );
};